<script lang="ts" setup>
// the contents of the person modal, shared between the route version
// (`pages/people/[slug].vue`) and the overlay (`site/person-overlay.vue`).
// the close control differs between the two -- a link back to the list vs a
// button -- so it comes in through the slot
defineProps<{
  data: any
}>()
</script>

<template>
  <div class="grid grid-cols-[1fr_auto] gap-1 m-1">
    <pages-people-slug-header :data="data" />

    <slot name="close" />
  </div>

  <pages-people-slug
    class="m-1"
    :data="data"
  />
</template>
